module.exports = __webpack_public_path__ + "img/sub-menu.f4899fac.svg";